<template>
  <div></div>
</template>

<script>
import * as token from '../../../services/auth/token';

export default {
  name: 'AuthLogout',
  created() {
    token.destroy();
  },
};
</script>



// WEBPACK FOOTER //
// Logout.vue?0b7b813d